module.exports = __webpack_public_path__ + "static/media/module_gamification.b4231333.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_gamification.jpg
// module id = ./src/resources/images/modules/module_gamification.jpg
// module chunks = 0